'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { SPARTAN_ENGINE_SECTION_IDS } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/section-slider/constants';
import { type PaginationBulletsProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/section-slider/pagination-bullets/types';
import { SPARTAN_ENGINE_HERO_DATA_GA, SPARTAN_ENGINE_HERO_TRACKING } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/tracking';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { SPARTAN_ENGINE_EVENT_NAME } from '@/app/lcv/components/sections/spartan/engine/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
const clamp01 = (value: number) => Math.min(1, Math.max(0, value));
export const PaginationBullets = t0 => {
  const $ = _c(20);
  const {
    count,
    activeIndex,
    progressRef,
    isProgressAnimated: t1,
    isProgressPaused: t2,
    onSelect,
    className
  } = t0;
  const isProgressAnimated = t1 === undefined ? true : t1;
  const isProgressPaused = t2 === undefined ? false : t2;
  const activeRingRef = useRef(null);
  let t3;
  let t4;
  if ($[0] !== activeIndex || $[1] !== isProgressAnimated || $[2] !== isProgressPaused || $[3] !== progressRef) {
    t3 = () => {
      if (!isProgressAnimated || isProgressPaused) {
        return;
      }
      const ring = activeRingRef.current;
      if (!ring) {
        return;
      }
      let frame = 0;
      const tick = () => {
        const {
          index,
          progress
        } = progressRef.value;
        const filled = index === activeIndex ? clamp01(progress) : 1;
        ring.setAttribute("stroke-dashoffset", String(1 - filled));
        if (index === activeIndex && filled >= 1) {
          frame = 0;
          return;
        }
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      return () => {
        if (frame) {
          cancelAnimationFrame(frame);
        }
      };
    };
    t4 = [activeIndex, isProgressAnimated, isProgressPaused, progressRef];
    $[0] = activeIndex;
    $[1] = isProgressAnimated;
    $[2] = isProgressPaused;
    $[3] = progressRef;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== activeIndex || $[7] !== isProgressAnimated) {
    t5 = index_0 => {
      if (index_0 !== activeIndex) {
        return index_0 < activeIndex ? 1 : 0;
      }
      return isProgressAnimated ? 0 : 1;
    };
    $[6] = activeIndex;
    $[7] = isProgressAnimated;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const initialFilledAt = t5;
  let t6;
  if ($[9] !== className) {
    t6 = cn("flex flex-col items-center gap-4", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: SPARTAN_ENGINE_HERO_TRACKING.pagination
    });
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== activeIndex || $[13] !== count || $[14] !== initialFilledAt || $[15] !== onSelect) {
    t8 = Array.from({
      length: count
    }, (_, index_1) => {
      const isActive = index_1 === activeIndex;
      return <button key={index_1} type="button" aria-label={`Go to section ${index_1 + 1}`} aria-current={isActive || undefined} onClick={() => onSelect(index_1)} className={cn("group size-4 cursor-pointer p-2", styles.paginationBullet, {
        [styles.active]: isActive
      })} {...createDataAttributes({
        test: SPARTAN_ENGINE_HERO_TRACKING.paginationBullet(index_1)
      })} {...createDataGA({
        eventName: SPARTAN_ENGINE_EVENT_NAME,
        group: SPARTAN_ENGINE_HERO_DATA_GA.section,
        click: true,
        text: `Go to section ${index_1 + 1}`,
        value: SPARTAN_ENGINE_SECTION_IDS[index_1]
      })}><svg className={styles.paginationRing} viewBox="0 0 16 16" aria-hidden={true} focusable="false"><circle className={styles.paginationRingTrack} cx="8" cy="8" r="7" /><circle ref={isActive ? activeRingRef : undefined} className={styles.paginationRingProgress} cx="8" cy="8" r="7" pathLength={1} strokeDasharray={1} strokeDashoffset={1 - initialFilledAt(index_1)} /></svg></button>;
    });
    $[12] = activeIndex;
    $[13] = count;
    $[14] = initialFilledAt;
    $[15] = onSelect;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className={t6} {...t7}>{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};